import { Attributes, List, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';
import BusinessUnit from './BusinessUnit';

@NeoModel
export default class Group extends ModelBase {
    static typeName = "Group";

    public groupId: number = 0;

    @Rules.StringLength(10)
    @Rules.Required()
    public groupCode: string = "";

    @Rules.StringLength(50)
    @Rules.Required()
    @Attributes.Display("Group")
    public groupName: string = "";

    public businessUnits = new List(BusinessUnit);

    // Client only properties / methods

    @Attributes.NoTracking()
    public isExpanded = false;

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.groupCode) {
            return "New group";
        } else {
            return this.groupCode;
        }
    }
}